import MainRoute from "./Pages/MainRoute";

function App() {
  return (
    <div className="App">
      <MainRoute />
    </div>
  );
}

export default App;
